// @flow @jsx h

import { h } from 'preact'
import { Button } from '../Foreground/common/Button'
import styles from './ButtonGroup.css'

type Props = {
  restart: () => void,
  toggleModal: () => void
}

const ButtonGroup = ({ restart, toggleModal }: Props) => {
  return (
    <div class={styles['button-group']}>
      <Button
        onClick={toggleModal}
        modifiers={['icon', 'inverted']}
        aria-label='Åpne ekstra informasjon'
      >
        <span aria-hidden>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='2 3 10 10'
            width='200px'
          >
            <path d='M7.5 3.62c-.33 0-.6.2-.6.53 0 .32.27.52.6.52.32 0 .56-.2.56-.52s-.25-.53-.57-.53zm.45 2.1H6.4v.5l.75.22v4.35l-.77.22v.48h2.34v-.48l-.77-.23V5.7z' />
          </svg>
        </span>
      </Button>
    </div>
  )
}

export { ButtonGroup }



// WEBPACK FOOTER //
// ./src/v1/components/Overlay/ButtonGroup.js